import { render, staticRenderFns } from "./RegulatePlan.vue?vue&type=template&id=2a26bae4&scoped=true&"
import script from "./RegulatePlan.vue?vue&type=script&lang=js&"
export * from "./RegulatePlan.vue?vue&type=script&lang=js&"
import style0 from "./RegulatePlan.vue?vue&type=style&index=0&id=2a26bae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a26bae4",
  null
  
)

export default component.exports